export default __webpack_public_path__ + "static/media/topfivephoto.9475b90a.png";